var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0999 6.96216C19.5037 7.22718 18.8639 7.40692 18.1917 7.48716C18.878 7.07488 19.4034 6.42093 19.6524 5.64409C19.0086 6.0259 18.298 6.30314 17.5407 6.45343C16.9344 5.80455 16.0719 5.40039 15.1152 5.40039C13.2799 5.40039 11.7918 6.89312 11.7918 8.73314C11.7918 8.9941 11.8212 9.24898 11.8779 9.49271C9.11631 9.35357 6.66754 8.02638 5.02861 6.00965C4.74212 6.50115 4.57914 7.07384 4.57914 7.68517C4.57914 8.84179 5.16628 9.86233 6.05713 10.4594C5.51249 10.4411 5.00026 10.2908 4.55182 10.041V10.0827C4.55182 11.6972 5.69776 13.0448 7.21723 13.3514C6.93884 13.4266 6.64528 13.4682 6.34158 13.4682C6.12698 13.4682 5.91945 13.4469 5.71597 13.4063C6.13911 14.7315 7.36605 15.6951 8.81973 15.7215C7.6829 16.6152 6.24946 17.1462 4.69254 17.1462C4.42429 17.1462 4.16006 17.13 3.8999 17.1005C5.3708 18.048 7.11704 18.6004 8.99386 18.6004C15.1072 18.6004 18.4488 13.521 18.4488 9.11598L18.4377 8.68441C19.0906 8.21727 19.6555 7.63034 20.0999 6.96216Z",
    fill: "#1D9BF0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterFilled);
export default __webpack_public_path__ + "static/media/twitter-filled.4c5c78e0f3dcfc0b659e4d940704dbbe.svg";
export { ForwardRef as ReactComponent };